import { render, staticRenderFns } from "./EstadoPage.vue?vue&type=template&id=c0a0d2b4"
import script from "./EstadoPage.js?vue&type=script&lang=js&external"
export * from "./EstadoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports